import { render, staticRenderFns } from "./Notebook.vue?vue&type=template&id=5cb233e6&"
import script from "./Notebook.vue?vue&type=script&lang=js&"
export * from "./Notebook.vue?vue&type=script&lang=js&"
import style0 from "./Notebook.vue?vue&type=style&index=0&id=5cb233e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports